import { EventrDate } from '@eventr/common'
import {
    DatePicker,
    MainButton,
    TimePicker,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { useState } from 'react'
import i18n from '../../../i18n/i18next'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { useGlobalRouter } from '../../globalRouter/useGlobalRouter'
import { NavigationView } from '../../layout/NavigationView'

export const TimeSettingsPage = () => {
    const { goBack } = useGlobalRouter()
    const { getLanguageISO639Code } = useLanguageContext()

    const [overrideDate, setOverrideDate] = useState<string | undefined>(
        localStorage.getItem('overrideDate') ?? undefined
    )
    const _setOverrideDate = (date: string) => {
        setOverrideDate(date)
        localStorage.setItem('overrideDate', date)
    }
    return (
        <Box paddingTop={'10px'}>
            <NavigationView
                navigationBarTitle="Time Settings"
                backButtonAction={goBack}
                usePageTransition
            >
                <DatePicker
                    date={overrideDate}
                    onSave={(data) => {
                        const eDate = new EventrDate(data)
                        _setOverrideDate(eDate.dateTimeString)
                    }}
                    locale={getLanguageISO639Code()}
                    selectText={i18n.t('edit-itinerary.fields.select-date')}
                    saveText={i18n.t('general.done')}
                    clearText={i18n.t('general.clear')}
                />
                <TimePicker
                    time={overrideDate}
                    onSave={(time) => {
                        const eTime = new EventrDate(time)
                        const eDate = new EventrDate(overrideDate)
                        eDate.setFromObject({
                            hour: eTime.itinLocalLuxon.hour,
                            minute: eTime.itinLocalLuxon.minute,
                        })
                        _setOverrideDate(eDate.dateTimeString)
                    }}
                />

                <Typography>
                    {'Current datetime override ' + overrideDate}
                </Typography>
                <MainButton
                    onClick={() => {
                        localStorage.removeItem('overrideDate')
                    }}
                >
                    Clear override
                </MainButton>
            </NavigationView>
        </Box>
    )
}
